/**
 * Safely retrieves an item from sessionStorage.
 *
 * @param key - The storage key to retrieve
 * @returns The stored value as a string, or null if the key doesn't exist or access fails
 *
 */ function getSessionStorageItem(key) {
    try {
        return globalThis.sessionStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

export { getSessionStorageItem };
//# sourceMappingURL=get-session-storage-item.js.map
